// QR Menü masa yönetimi ekranı kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.qrTables';

export const qrTablesGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Masa Yönetimi nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'QR menülerinize bağlı masaları görür, adlarını düzenler ve masalara yapıştıracağınız QR kodları indirirsiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    toolbar: t(`${G}.regions.toolbar`, 'Menü başlığı ve toplu indirme'),
    table: t(`${G}.regions.table`, 'Masa kartları'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Masalar QR menüye bağlıdır'),
      text: t(`${G}.s1.text`, 'Her QR menü ayrı bir bölüm olarak listelenir. Masa eklemek bu ekrandan değil, QR Menü sayfasındaki "Masa Ekle" düğmesinden yapılır. Hiç QR menü yoksa önce QR menü oluşturmanız gerekir.'),
    },
    {
      region: 'toolbar',
      title: t(`${G}.s2.title`, '2. Menüyü açın'),
      text: t(`${G}.s2.text`, 'Bir menü başlığına tıklayınca masaları yüklenir; aynı anda yalnız bir menü açık kalır. Başlıkta menü adı, şubesi ve masa sayısı görünür.'),
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Masa adını düzenleyin'),
      text: t(`${G}.s3.text`, 'Masa kartındaki kalem düğmesi "Masa Adını Düzenle" penceresini açar. VIP Masa, Pencere Kenarı gibi bir ad yazıp "Kaydet"e basın.'),
      tips: [
        t(`${G}.s3.tip1`, 'Ad değişse de masanın QR kodu değişmez; QR kod masa numarasına bağlıdır, basılı kodları yenilemeniz gerekmez.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Masanın QR kodunu indirin'),
      text: t(`${G}.s4.text`, 'QR düğmesi o masanın kodunu yüksek çözünürlüklü (4K) PNG olarak indirir. Kodun ortasında masa numarası yazar; yazdırıp masaya yapıştırın. Müşteri kodu okutunca menü o masa için açılır.'),
    },
    {
      region: 'toolbar',
      title: t(`${G}.s5.title`, '5. Tüm QR kodları tek seferde indirin'),
      text: t(`${G}.s5.text`, 'Menü açıkken başlıktaki yeşil "Tüm QR Kodlarını İndir" düğmesi menüdeki bütün masaların kodlarını tek bir ZIP dosyasında indirir. İlerleme penceresinde her masanın durumu görünür; bitince "Kapat"a basın.'),
    },
    {
      region: 'table',
      title: t(`${G}.s6.title`, '6. Masayı silin'),
      text: t(`${G}.s6.text`, 'Çöp kutusu düğmesi onay ister; "Evet, Sil" ile masa kalıcı olarak silinir. Bu işlem geri alınamaz ve o masanın basılı QR kodları geçersiz olur.'),
    },
  ],
});
